import { canUseAssistant } from '@otm/shared/auth';
import { REDUCED_ACCESS_ACCOUNT_TYPES } from 'constants/optionLists';
import { UserContext } from 'types/auth';
import { Contact } from 'types/contact';

export default function authDefinitions(firebaseUser: any, contact: Contact): UserContext {
  const {
    accountTypes,
    id,
    authorizations,
    accountLevel,
    nameFirst,
    nameSecond,
    techInfoDashboard
  } = contact;

  return {
    uid: firebaseUser?.uid,
    email: firebaseUser?.email,
    name: `${nameFirst} ${nameSecond}`,
    accountTypes,
    accountLevel,
  authorizations: authorizations || [],
    contactId: id,
    isStaff: accountTypes?.includes('Staff'),
    isAdmin: accountLevel === 'Admin' || accountLevel === 'Super Admin',
    isTopSecret:
      authorizations?.includes('View Top Secret Financials') || accountLevel === 'Super Admin',
    isBandleader: accountTypes?.includes('Bandleader'),
    isStrings: accountTypes?.includes('Strings'),
    isHorns: accountTypes?.includes('Horns'),
    isPercussion: accountTypes?.includes('Percussion'),
    techInfoDashboard: !!techInfoDashboard,
    viewContractorRates:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('View Contractor Rates'),
    viewSalesFigures:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('View Sales Figures'),
    viewExpenses:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('View Expenses'),
    viewDeposits:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('View Deposits'),
    viewBankDetails:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('View Bank Details'),
    canUseAssistant: canUseAssistant({ accountLevel, authorizations }),
    /* Details page access
      PDF page access (not contract)
      No histories
      Only their events in the list
      Can't set account types
      No rates */
    isReducedAccess01:
      REDUCED_ACCESS_ACCOUNT_TYPES.some((type) => accountTypes?.includes(type)) &&
      !accountTypes?.includes('Staff'),
    setPaymentNotifications:
      accountLevel === 'Admin' ||
      accountLevel === 'Super Admin' ||
      authorizations?.includes('Set Payment Notifications')
  };
}
